import { render } from "./HeroiconsSolidShieldCheck.vue?vue&type=template&id=b509a0ce"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidShieldCheck.vue"]])

export default __exports__